export default __webpack_public_path__ + "static/media/Acolyte's Harness of the Eighteen Pits.0cc63a12.jpg";